import { CropCycle, CropCycleV2 } from "@/types/cropCycle";
import dayjs from "dayjs";

export function getCropCycleDisplay(cropCycle: CropCycle) {
    const cropName = cropCycle.crop
        ? cropCycle.crop
        : !cropCycle.end_date
          ? "Current"
          : " Corn";
    const yearStart = dayjs(cropCycle.start_date).year();
    const yearEnd = (
        cropCycle.end_date ? dayjs(cropCycle.end_date) : dayjs()
    ).year();
    if (yearStart == yearEnd) {
        return `${cropName} ${yearStart}`;
    } else {
        return `${cropName} ${yearStart}-${yearEnd}`;
    }
}

export function isDefaultCropCycle(cropCycle: CropCycleV2) {
    return (
        !cropCycle.planting_operation || cropCycle.planting_operation === -1
    );
}

export const UNSAVED_CROP_CYCLE_SEARCH_ID = -1;

export function getCropCycleSearchId(cropCycle: CropCycleV2) {
    return cropCycle.id ?? UNSAVED_CROP_CYCLE_SEARCH_ID;
}

export function getCropCycleKey(cropCycle: CropCycleV2) {
    if (cropCycle.id != null) return String(cropCycle.id);
    return `default-${cropCycle.start_date}-${cropCycle.end_date}-${cropCycle.crop_zone ?? "none"}`;
}

export function findCropCycleBySearchId(
    cropCycles: CropCycleV2[],
    searchId: number,
) {
    if (searchId === UNSAVED_CROP_CYCLE_SEARCH_ID) {
        return cropCycles.find((cycle) => cycle.id == null) ?? null;
    }
    return cropCycles.find((cycle) => cycle.id === searchId) ?? null;
}

export function getCropCycleV2Display(cropCycle: CropCycleV2) {
    return `${cropCycle.effective_planting_operation.crop_configuration.crop_name} ${dayjs(cropCycle.effective_planting_operation.start_date).year()}`;
}
